import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterSp'
})
export class FilterSpPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if(!items) return [];
    if(!searchText) return items;
searchText = searchText.toLowerCase();

return items.filter( it => {
      return String(it.noSolPed).includes(searchText);
    });
   }

}



// WEBPACK FOOTER //
// ./src/app/pipes/filter-sp.pipe.ts